/**
 * Analytics Tracker - Unified event tracking abstraction
 *
 * Routes analytics events to the active provider (GTM or Yandex Metrica)
 * based on window.appconfig.analytics_provider.
 *
 * Usage:
 *   window.analyticsTrack('event_name', { key: 'value' });
 */

(function () {
  var provider = (window.appconfig && window.appconfig.analytics_provider) || 'gtm';
  var ymCounterId = window.appconfig && window.appconfig.yandex_metrica_counter_id;

  /**
   * Track an analytics event.
   *
   * @param {string} eventName - The event name (e.g. 'deal_clicked')
   * @param {Object} [eventData={}] - Additional event parameters
   */
  function analyticsTrack(eventName, eventData) {
    eventData = eventData || {};

    if (provider === 'gtm') {
      window.dataLayer = window.dataLayer || [];
      var payload = Object.assign({ event: eventName }, eventData);
      window.dataLayer.push(payload);
    } else if (provider === 'yandex_metrica') {
      if (typeof window.ym === 'function' && ymCounterId) {
        window.ym(ymCounterId, 'reachGoal', eventName, eventData);
      }
    }
  }

  /**
   * Track a page view with custom parameters.
   *
   * @param {string} url - The page URL
   * @param {Object} [params={}] - Additional parameters
   */
  function analyticsPageView(url, params) {
    params = params || {};

    if (provider === 'gtm') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'page_view', page_url: url }, params));
    } else if (provider === 'yandex_metrica') {
      if (typeof window.ym === 'function' && ymCounterId) {
        window.ym(ymCounterId, 'hit', url, params);
      }
    }
  }

  /**
   * Set user parameters for the analytics provider.
   *
   * @param {Object} userParams - User properties (e.g. { user_id: 123, logged_in: true })
   */
  function analyticsSetUser(userParams) {
    userParams = userParams || {};

    if (provider === 'gtm') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'set_user' }, userParams));
    } else if (provider === 'yandex_metrica') {
      if (typeof window.ym === 'function' && ymCounterId) {
        window.ym(ymCounterId, 'userParams', userParams);
      }
    }
  }

  // Expose globally
  window.analyticsTrack = analyticsTrack;
  window.analyticsPageView = analyticsPageView;
  window.analyticsSetUser = analyticsSetUser;
})();
